/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EditorSuggestionType {
    Base = '0',
    Primary = 1,
    Alternative = 2,
}
